import { render, staticRenderFns } from "./xiaoqu-level.vue?vue&type=template&id=5374b87d&scoped=true"
import script from "./xiaoqu-level.vue?vue&type=script&lang=js"
export * from "./xiaoqu-level.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5374b87d",
  null
  
)

export default component.exports